import { AppFirestore } from './friestore.service';

export class AppFirebase {
  static db = AppFirestore;
}
